<!--
  修改手机号
-->
<template>
  <div class=''>
    <title-header title='修改手机号'></title-header>
    <div class='change-phone-box'>
      <i class="iconfont icon-shouji phone-icon"></i>
      <div>为了您的账户安全，需要验证您的手机</div>
      <div>{{phone | hidePhone}}</div>
      <van-field
        v-model="phoneCode1"
        size="large"
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode1">
          <span v-show="!display.showWait1">发送验证码</span>
          <span v-show="display.showWait1">{{waitSecond1}}s</span>
        </van-button>
      </van-field>

      
      <div class='new-phone-tip'>请填写新手机号码</div>
      <!-- 新手机号 -->
      <van-field
        v-model="newPhone" 
        label='新手机号' 
        size="large" 
        placeholder="请输入手机号"
      ></van-field>
      <van-field
        v-model="phoneCode2"
        size="large"
        label="验证码"
        placeholder="请输入新手机验证码"
      >
        <van-button slot="button" size="small" color="#45C5DA" type="primary" @click="sendCode2">
          <span v-show="!display.showWait2">发送验证码</span>
          <span v-show="display.showWait2">{{waitSecond2}}s</span>
        </van-button>
      </van-field>
      <van-button style="width: 35vw;margin-top:40px;" color='#45C5DA' @click="changePhone">完成</van-button>
    </div>
    <geetest
      ref="geetest1"
      :phone="phone"
      :page-code="pageCode1"
      :val-code="pageCode1"
      @send-code-success="handlerSendCodeSuccess1"
      @send-code-error="handlerSendCodefailed1"
    ></geetest>
    
    <geetest
      ref="geetest2"
      :phone="newPhone"
      :page-code="pageCode2"
      :val-code="pageCode2"
      @send-code-success="handlerSendCodeSuccess2"
      @send-code-error="handlerSendCodefailed2"
    ></geetest>
  </div>
</template>
<script>
  import { randomString } from 'common/js/utils';
  import geetest from "components/geetest/geetest.vue";
  import { Toast } from 'vant';
  import api from 'api/security-center';
  import { mapActions } from 'vuex';
  export default {
    components: {
      geetest
    },
    data() {
      return {
        display: {
          showWait1: false,
          showWait2: false
        },
        newPhone: '',//新手机号
        phoneCode1: '',//旧手机号验证码
        phoneCode2: '', //新手机号验证码
        waitSecond1: 60,
        waitSecond2: 60,
        pageCode1: randomString(8), //手机验证所需要的随机字符串
        pageCode2: randomString(8), //手机验证所需要的随机字符串
      }
    },
    computed: {
      phone() {
        const phone = this.$store.state.userInfo.mobilePhone
        if(phone) {
          return phone
        }
        return ''
      },
    },
    methods: {
      //发送旧手机验证码
      sendCode1() {   
        if (this.display.showWait1) return
        this.$refs.geetest1.verify();
      },
      //发送新手机验证码
      sendCode2() {
        if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
          Toast('新手机号格式错误')
          return
        }
        this.$refs.geetest2.verify();
      },
      //提交修改手机号
      changePhone() {
        if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
          Toast('新手机号格式错误')
          return
        }
        if( !this.phoneCode1 || !this.phoneCode2) {
          Toast('请填写手机验证码')
          return
        }
        api.updatePhone({
          oldMobileCode: this.phoneCode1,
          newMobilePhone: this.newPhone,
          newMobileCode: this.phoneCode2
        })
          .then(res => {
            Toast.success('修改成功')
              this.getuserInfo()
              this.$router.go(-1);
          })
          .catch(res => {
            Toast.fail(res)
          })
      },
      //发送成功
      handlerSendCodeSuccess1() {
        this.display.showWait1 = true;
        this.secondWait1()
      },
      //发送成功
      handlerSendCodeSuccess2() {
        this.display.showWait2 = true;
        this.secondWait2()
      },
      handlerSendCodefailed1() {

      },
      handlerSendCodefailed2() {

      },
      secondWait1: function() {
        let _this = this;
        _this.setInercalID1 = setTimeout(function() {
          if (_this.waitSecond1 > 0) {
            _this.waitSecond1 = _this.waitSecond1 - 1;
            _this.secondWait1();
          } else {
            _this.display.showWait1 = false;
            clearTimeout(_this.setInercalID1);
            _this.waitSecond1 = 60;
          }
        }, 1000);
      },
      secondWait2: function() {
        let _this = this;
        _this.setInercalID2 = setTimeout(function() {
          if (_this.waitSecond2 > 0) {
            _this.waitSecond2 = _this.waitSecond2 - 1;
            _this.secondWait2();
          } else {
            _this.display.showWait2 = false;
            clearTimeout(_this.setInercalID2);
            _this.waitSecond2 = 60;
          }
        }, 1000);
      },
      ...mapActions(['getuserInfo'])
    }
  }
</script>
<style scoped lang='scss'>
  .change-phone-box{
    display: flex;
    align-items: center;
    flex-direction: column;
    .phone-icon{
      margin-top: 50px;
      font-size: 35px;
      font-weight: bold;
      color: #000;
    }
    .phone{
      margin-bottom: 20px;
    }
    .new-phone-tip{
      margin-top: 40px;
      font-size: 18px;
    }
  }
</style>

